import React, { useEffect, useState } from 'react'
import http from './../../services/Api'
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import { ModalManager } from 'react-dynamic-modal';

import AresNavBar from './../Layout/NavBar/NavBar'
import SideBar from '../Layout/SideBar/SideBar'

import { MapContainer } from './Map'

import './index.css'
import 'react-data-table-component-extensions/dist/index.css';
import { Col, Row, Spinner } from 'react-bootstrap';
import { AiOutlineEdit } from 'react-icons/ai';
import { BsTrash } from 'react-icons/bs';
import { RiMapPin2Line } from 'react-icons/ri';
import swal from 'sweetalert';
import ConfigModal from './config';

//datatable config
const customStyles = {
	rows: {
		style: {
			'&:hover': {
				backgroundColor: '#03989E',
				color: 'white',
				transition: '.2s'
			},
		}
	},
};

export default function Place() {
	const [places, setPlaces] = useState([])
	const [columsTitle, setColumsTitle] = useState([])
	const [loading, setLoading] = useState(false)
	const [zoom, setZoom] = useState(10)
	const [lat, setLat] = useState(-15.7801)
	const [lng, setLng] = useState(-47.9292)
	const [selectedPlace, setSelectedPlace] = useState({})

	useEffect(() => {
		getPlaces()
		setColumsTitle(columns)
	}, [lat, lng]);

	const columns = [
		{
			name: 'Nome',
			selector: 'name',
			sortable: true,
			width: '20%'
		},
		{
			name: 'Endereço',
			selector: 'address',
			sortable: true,
			width: '30%'
		},
		{
			name: 'Quantidade de Dipositivos',
			selector: 'devices',
			sortable: true,
			center: true,
			width: '20%'
		},
		{
			name: '',
			cell: (row) => (
				<Row>
					<Col>
						<button className="edit-address-button" onClick={() => {
							openModal(row, 'edit')
						}}>
							Editar
						<AiOutlineEdit />
						</button>
					</Col>
					<Col>
						{renderPlaceButton(row)}
					</Col>
					<Col>
						<button className="delete-address-button" onClick={() => {
							openModal(row, 'delete')
						}}>
							Remover
						<BsTrash />
						</button>
					</Col>
				</Row>
			),
			sortable: true,
			width: '30%'
		},
	];

	async function getPlaces() {
		setLoading(true)
		try {
			let response = await http.get('/api/locations');
			setPlaces(response.data)
			setLoading(false)
		} catch (e) {
			swal("Erro!", "Não foi possível encontrar locais", "error");
			console.log(e)
		}
	}

	function openModal(place, modal) {
		ModalManager.open(<ConfigModal place={place} modal={modal} />)
	}

	return (
		<div>
			<AresNavBar />
			<SideBar />
			<div className="Place">
				{loading ?
					<div className="center-page">
						<Spinner animation="border" />
					</div>
					:
					<div>
						<div className="container-header">
							<div className="center pointer">
								<h1>Locais</h1>
							</div>
						</div>
							<div className="container-list">
								{renderTable(places, columsTitle)}
							</div>
						<hr id="map" />
						{renderMap()}
					</div>
				}
			</div>
		</div>
	)

	function renderTable(data, colums) {
		const seachData = {
			data,
			columns
		}

		return (
			<div className="container-fluid">
				<DataTableExtensions
					{...seachData}
					filterPlaceholder="Pesquisar Locais"
					print={false}>
					<DataTable
						columns={colums}
						data={data}
						pagination={true}
						responsive
						noDataComponent={
							<span>Nenhum registro de locais encontrado</span>
						}
						customStyles={customStyles}
					/>
				</DataTableExtensions>
			</div>
		);
	}

	function renderPlaceButton(row) {
		return (
			<button className="map-address-button" onClick={() => {
				setLat(row.latitude)
				setLng(row.longitude)
				setSelectedPlace(row)
				setZoom(18)
			}}>
				Local
				<RiMapPin2Line />
			</button>
		);
	}

	function renderMap() {
		return (
			<div>
				<MapContainer
					places={places}
					lat={lat}
					lng={lng}
					zoom={zoom}
					selectedTablePlace={selectedPlace} />
			</div>
		)
	}
}
